export const getRndFromArray = (arr: any[], count: number = 1): any[] | any => {
  if (!arr || !arr?.length) {
    return count > 1 ? [] : undefined
  }
  // if (count === 1) {
  //   return arr[Math.floor(Math.random() * arr.length)]
  // }
  const res: any[] = []
  const used: number[] = []
  while (res.length < count && arr.length > used.length) {
    const x = Math.floor(Math.random() * arr.length)
    if (!used.includes(x)) {
      res.push(arr[x])
      used.push(x)
    }
  }
  // for (const _ of new Array(count)) {
  //   const x = Math.floor(Math.random() * arr.length)
  //   if (!used.includes(x)) {
  //     res.push(arr[x])
  //     used.push(x)
  //   } else {
  //     const f = getRndFromArray(arr, 1);
  //     res.push(f)
  //   }
  // }
  const uniq = Array.from(new Set(res))
  return uniq?.length === 1 ? uniq[0] : uniq
}

export const shuffleArray = (arr: any[]) =>
  arr
    .map((value: any) => ({ value, sort: Math.random() }))
    .sort((a: any, b: any) => a.sort - b.sort)
    .map(({ value }: any) => value)
export type GameStatus = 'success' | 'error' | null

export const vibrate = (pattern: number | number[] = 100) => {
  if (window.navigator.vibrate) {
    window.navigator.vibrate(pattern)
  }
}
